import type { AppRouteBeforeServerRenderContext } from '#src/shared/routes';

import { petitionSlugCanonicalRedirect } from '#src/app/shared/routes';

export async function shareUrlCanonicalRedirect(context: AppRouteBeforeServerRenderContext): Promise<void> {
	await petitionSlugCanonicalRedirect(context, !context.isBot());
}
